import { action } from "typesafe-actions";

import { message } from "antd";

import {
  DateRangePayload,
  GatePayload,
  OrderingPayload,
  PaginatedResponse,
  PaginationPayload,
  ReportPayload,
} from "../common_types";
import { CurrencyPayload } from "../currencies/types";
import { MarketPayload } from "../markets/types";

import { BookingItem, BookingsActionTypes, BookingsPayload } from "./types";

export const bookingsFetchRequest = (
  payload: BookingsPayload &
    DateRangePayload &
    PaginationPayload &
    MarketPayload &
    CurrencyPayload &
    OrderingPayload &
    GatePayload
) => action(BookingsActionTypes.DATA_FETCH_REQUEST, payload);

export const bookingsFetchSuccess = (payload: PaginatedResponse<BookingItem>) =>
  action(BookingsActionTypes.DATA_FETCH_SUCCESS, payload);

export const bookingsFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(BookingsActionTypes.DATA_FETCH_ERROR);
};

export const reportGeneratorTaskCreateRequest = (
  payload: ReportPayload &
    BookingsPayload &
    DateRangePayload &
    MarketPayload &
    CurrencyPayload &
    OrderingPayload &
    GatePayload
) => action(BookingsActionTypes.GENERATE_REPORT_REQUEST, payload);
